import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import facebook from '../../../../assets/images/facebook_24px.svg';
import instagram from '../../../../assets/images/instagram_24px.svg';
import pinterest from '../../../../assets/images/pintrest_24px.svg';
import youtube from '../../../../assets/images/youtube_24px.svg';
import { Link } from '../../../../components/Footer/components/Links/components/Link/index.js';
import { Container } from '../../../../components/Footer/components/SocialLinks/components/Container.js';
import { NextImage } from '../../../../components/internal/NextImage/NextImage.js';
import { qaId } from '../../../../utils/index.js';
import { FOOTER_QA_ID } from '../../../../utils/qaId.js';
export const SocialLinks = /*#__PURE__*/_styled(({
  links = [],
  ...restProps
}) => {
  const {
    t
  } = useTranslation(['footer']);
  const socialImages = {
    facebook,
    instagram,
    youtube,
    pinterest
  };
  return _jsx(Container, {
    ...restProps,
    "data-testid": qaId(FOOTER_QA_ID, 'links', 'social'),
    children: links.map(({
      label,
      url,
      masked = false
    }) => _jsx(Link
    // @ts-expect-error TS(2322) FIXME
    , {
      // @ts-expect-error TS(2322) FIXME
      href: url,
      target: '_blank',
      rel: "noreferrer",
      ariaLabel: t(label),
      masked: masked,
      children: _jsx(NextImage, {
        image: socialImages[label],
        alt: `${label}icon`
      })
    }, label))
  });
}, process.env.NODE_ENV === "production" ? {
  target: "ec55tuk0"
} : {
  target: "ec55tuk0",
  label: "SocialLinks"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCRyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyB1c2VUcmFuc2xhdGlvbiB9IGZyb20gJ25leHQtaTE4bmV4dCc7XG5pbXBvcnQgZmFjZWJvb2sgZnJvbSAnLi4vLi4vLi4vLi4vYXNzZXRzL2ltYWdlcy9mYWNlYm9va18yNHB4LnN2Zyc7XG5pbXBvcnQgaW5zdGFncmFtIGZyb20gJy4uLy4uLy4uLy4uL2Fzc2V0cy9pbWFnZXMvaW5zdGFncmFtXzI0cHguc3ZnJztcbmltcG9ydCBwaW50ZXJlc3QgZnJvbSAnLi4vLi4vLi4vLi4vYXNzZXRzL2ltYWdlcy9waW50cmVzdF8yNHB4LnN2Zyc7XG5pbXBvcnQgeW91dHViZSBmcm9tICcuLi8uLi8uLi8uLi9hc3NldHMvaW1hZ2VzL3lvdXR1YmVfMjRweC5zdmcnO1xuaW1wb3J0IHsgTGluayB9IGZyb20gJy4uLy4uLy4uLy4uL2NvbXBvbmVudHMvRm9vdGVyL2NvbXBvbmVudHMvTGlua3MvY29tcG9uZW50cy9MaW5rL2luZGV4LmpzJztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uLy4uLy4uL2NvbXBvbmVudHMvRm9vdGVyL2NvbXBvbmVudHMvU29jaWFsTGlua3MvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgTmV4dEltYWdlIH0gZnJvbSAnLi4vLi4vLi4vLi4vY29tcG9uZW50cy9pbnRlcm5hbC9OZXh0SW1hZ2UvTmV4dEltYWdlLmpzJztcbmltcG9ydCB7IHFhSWQgfSBmcm9tICcuLi8uLi8uLi8uLi91dGlscy9pbmRleC5qcyc7XG5pbXBvcnQgeyBGT09URVJfUUFfSUQgfSBmcm9tICcuLi8uLi8uLi8uLi91dGlscy9xYUlkLmpzJztcbmV4cG9ydCBjb25zdCBTb2NpYWxMaW5rcyA9IHN0eWxlZCgoeyBsaW5rcyA9IFtdLCAuLi5yZXN0UHJvcHMgfSkgPT4ge1xuICAgIGNvbnN0IHsgdCB9ID0gdXNlVHJhbnNsYXRpb24oWydmb290ZXInXSk7XG4gICAgY29uc3Qgc29jaWFsSW1hZ2VzID0ge1xuICAgICAgICBmYWNlYm9vayxcbiAgICAgICAgaW5zdGFncmFtLFxuICAgICAgICB5b3V0dWJlLFxuICAgICAgICBwaW50ZXJlc3QsXG4gICAgfTtcbiAgICByZXR1cm4gKF9qc3goQ29udGFpbmVyLCB7IC4uLnJlc3RQcm9wcywgXCJkYXRhLXRlc3RpZFwiOiBxYUlkKEZPT1RFUl9RQV9JRCwgJ2xpbmtzJywgJ3NvY2lhbCcpLCBjaGlsZHJlbjogbGlua3MubWFwKCh7IGxhYmVsLCB1cmwsIG1hc2tlZCA9IGZhbHNlIH0pID0+IChfanN4KExpbmtcbiAgICAgICAgLy8gQHRzLWV4cGVjdC1lcnJvciBUUygyMzIyKSBGSVhNRVxuICAgICAgICAsIHsgXG4gICAgICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIFRTKDIzMjIpIEZJWE1FXG4gICAgICAgICAgICBocmVmOiB1cmwsIHRhcmdldDogJ19ibGFuaycsIHJlbDogXCJub3JlZmVycmVyXCIsIGFyaWFMYWJlbDogdChsYWJlbCksIG1hc2tlZDogbWFza2VkLCBjaGlsZHJlbjogX2pzeChOZXh0SW1hZ2UsIHsgaW1hZ2U6IHNvY2lhbEltYWdlc1tsYWJlbF0sIGFsdDogYCR7bGFiZWx9aWNvbmAgfSkgfSwgbGFiZWwpKSkgfSkpO1xufSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1pbmRleC5qcy5tYXAiXX0= */");